import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";

const useStyles = makeStyles((theme) => ({
  mainContainer: {
    background: "#090909",
  },
  timeLine: {
    position: "relative",
    padding: "1rem",
    margin: "0 auto",
    "&:before": {
      content: "''",
      position: "absolute",
      height: "100%",
      border: "1px solid tan",
      right: "40px",
      top: 0,
    },
    "&:after": {
      content: "''",
      display: "table",
      clear: "both",
    },
    [theme.breakpoints.up("md")]: {
      padding: "2rem",
      "&:before": {
        left: "calc(50% - 1px)",
        right: "auto",
      },
    },
  },
  timeLineItem: {
    padding: "1rem",
    borderBottom: "2px solid tan",
    position: "relative",
    margin: "1rem 3rem 1rem 1rem",
    clear: "both",
    "&:after": {
      content: "''",
      position: "absolute",
    },
    "&:before": {
      content: "''",
      position: "absolute",
      right: "-0.625rem",
      top: "calc(50% - 5px)",
      borderStyle: "solid",
      borderColor: "tomato tomato transparent transparent",
      borderWidth: "0.625rem",
      transform: "rotate(45deg)",
    },
    [theme.breakpoints.up("md")]: {
      width: "44%",
      margin: "1rem",
      "&:nth-of-type(2n)": {
        float: "right",
        margin: "1rem",
        borderColor: "tan",
      },
      "&:nth-of-type(2n):before": {
        right: "auto",
        left: "-0.625rem",
        borderColor: "transparent transparent tomato tomato",
      },
    },
  },
  timeLineYear: {
    textAlign: "center",
    maxWidth: "9.375rem",
    margin: "0 3rem 0 auto",
    fontSize: "1.8rem",
    color: "#fff",
    background: "tomato",
    lineHeight: 1,
    padding: "0.5rem 1rem",
    "&:before": {
      display: "none",
    },
    [theme.breakpoints.up("md")]: {
      textAlign: "center",
      margin: "0 auto",
      "&:nth-of-type(2n)": {
        float: "none",
        margin: "0 auto",
      },
      "&:nth-of-type(2n):before": {
        display: "none",
      },
    },
  },
  heading: {
    color: "tomato",
    padding: "3rem 0",
    textTransform: "uppercase",
  },
  subHeading: {
    color: "#fff",
    padding: 0,
    textTransform: "uppercase",
  },
  body1: {
    color: "tomato",
  },
  subtitle1: {
    color: "tan",
  },
  subtitle2: {
    color: "#6c6cbd",
  },
}));

const Resume = () => {
  const classes = useStyles();
  return (
    <Box component="header" className={classes.mainContainer}>
      <Typography variant="h4" align="center" className={classes.heading}>
        Experience and Education
      </Typography>
      <Box component="div" className={classes.timeLine}>

        {/* 2025 Entry - MTN Group */}
        <Typography
          variant="h2"
          className={`${classes.timeLineYear} ${classes.timeLineItem}`}
        >
          2025
        </Typography>
        <Box component="div" className={classes.timeLineItem}>
          <Typography
            variant="h5"
            align="center"
            className={classes.subHeading}
          >
            Software Engineer Consultant
          </Typography>
          <Typography variant="body1" align="center" className={classes.body1}>
            Entelect Software (Client: MTN Group)
          </Typography>
          <Typography
            variant="subtitle1"
            align="center"
            className={classes.subtitle1}
          >
            May 2025 - Present. Enhancing the MoMo Wallet Platform serving 16 African countries using React Native, React, and Express.js.
          </Typography>
          <Typography
             variant="subtitle1"
             align="center"
             display="block"
             className={classes.subtitle2}
           >
             Key Contributions:<br></br>
           </Typography>
           <Typography
             variant="subtitle1"
             align="center"
             display="block"
             className={classes.subtitle1}
           >
             Introduced system-wide localisation engine.<br></br>
             Architected dynamic user hierarchy and role system.<br></br>
           </Typography>
        </Box>

        {/* 2024 Entry - Deloitte USA */}
        <Typography
          variant="h2"
          className={`${classes.timeLineYear} ${classes.timeLineItem}`}
        >
          2024
        </Typography>
        <Box component="div" className={classes.timeLineItem}>
          <Typography
            variant="h5"
            align="center"
            className={classes.subHeading}
          >
            Software Engineer Consultant
          </Typography>
          <Typography variant="body1" align="center" className={classes.body1}>
            Entelect Software (Client: Deloitte USA)
          </Typography>
          <Typography
            variant="subtitle1"
            align="center"
            className={classes.subtitle1}
          >
            Jan 2024 - Apr 2025. Full-stack development for the Levvia Auditing Platform using React and .NET microservices.
          </Typography>
          <Typography
             variant="subtitle1"
             align="center"
             display="block"
             className={classes.subtitle2}
           >
             Key Contributions:<br></br>
           </Typography>
           <Typography
             variant="subtitle1"
             align="center"
             display="block"
             className={classes.subtitle1}
           >
             Increased auditor engagement metrics by 80%.<br></br>
             Drove Levvia 3.2 release to be the most stable in application history.<br></br>
             Established new technical documentation standards.<br></br>
           </Typography>
        </Box>

        {/* 2023 Entry - FNZ */}
        <Typography
          variant="h2"
          className={`${classes.timeLineYear} ${classes.timeLineItem}`}
        >
          2023
        </Typography>
        <Box component="div" className={classes.timeLineItem}>
          <Typography
            variant="h5"
            align="center"
            className={classes.subHeading}
          >
            Software Engineer Consultant
          </Typography>
          <Typography variant="body1" align="center" className={classes.body1}>
            Entelect Software (Client: FNZ)
          </Typography>
          <Typography
            variant="subtitle1"
            align="center"
            className={classes.subtitle1}
          >
             Mar 2023 - Dec 2023. Developed features for the OneX Investment Platform using React and .NET.
          </Typography>
          <Typography
            variant="subtitle1"
            align="center"
            display="block"
            className={classes.subtitle2}
          >
            Key Contributions:<br></br>
          </Typography>
          <Typography
            variant="subtitle1"
            align="center"
            display="block"
            className={classes.subtitle1}
          >
            Automated email notification system using .NET API.<br></br>
            Enabled financial deposits from related party accounts.<br></br>
          </Typography>
        </Box>

        {/* 2022 Entry - Education */}
        <Typography
          variant="h2"
          className={`${classes.timeLineYear} ${classes.timeLineItem}`}
        >
          2022
        </Typography>
        <Box component="div" className={classes.timeLineItem}>
          <Typography
            variant="h5"
            align="center"
            className={classes.subHeading}
          >
            BSc Honours Computer Science
          </Typography>
          <Typography variant="body1" align="center" className={classes.body1}>
            Stellenbosch University
          </Typography>
          <Typography
            variant="subtitle1"
            align="center"
            className={classes.subtitle1}
          >
            Completed in 2022.
          </Typography>
          <Typography
            variant="subtitle1"
            align="center"
            display="block"
            className={classes.subtitle2}
          >
            Achievements:<br></br>
          </Typography>
          <Typography
            variant="subtitle1"
            align="center"
            display="block"
            className={classes.subtitle1}
          >
            Entersekt Launchlab Hackathon 2nd Place 2022<br></br>
            Entelect University Hackathon 4th Place 2022<br></br>
          </Typography>
        </Box>

        {/* 2021 Entry - Education */}
        <Typography
          variant="h2"
          className={`${classes.timeLineYear} ${classes.timeLineItem}`}
        >
          2021
        </Typography>
        <Box component="div" className={classes.timeLineItem}>
          <Typography
            variant="h5"
            align="center"
            className={classes.subHeading}
          >
            BCom Mathematical Science
          </Typography>
          <Typography variant="body1" align="center" className={classes.body1}>
            Stellenbosch University
          </Typography>
          <Typography
            variant="subtitle1"
            align="center"
            className={classes.subtitle1}
          >
             Jan 2019 - Dec 2021.
          </Typography>
          <Typography
            variant="subtitle1"
            align="center"
            display="block"
            className={classes.subtitle2}
          >
            Achievements:<br></br>
          </Typography>
          <Typography
            variant="subtitle1"
            align="center"
            display="block"
            className={classes.subtitle1}
          >
            Entersekt Launchlab Hackathon Champions 2021<br></br>
            Optimus Programme (Top 5% Study Field) 2020<br></br>
          </Typography>
        </Box>

      </Box>
    </Box>
  );
};

export default Resume;